// eslint-disable-next-line no-unused-vars
import React, { memo, useState, useEffect, useRef } from 'react';
import { bool } from 'prop-types';

import CategoriesMenuComponent from 'Components/Menus/Categories';
import CategoriesStaticComponent from 'Components/Menus/CategoriesStatic';
import useCategories from 'Hooks/useCategories';
import useRouter from 'Hooks/useRouter';
import useScreen from 'Hooks/useScreen';
import usePermissions from 'Hooks/usePermissions';
import useScrollLock from 'Hooks/useScrollLock';

const CategoriesMenu = memo(({ isStatic = false }) => {
  const containerRef = useRef(null);
  const { location } = useRouter();
  const { width } = useScreen();
  const { isExternalReseller, canAccessAccountStatements } = usePermissions();
  const { data: categories, error, activeCategory, activeCategoryParts } = useCategories();
  const [open, setOpen] = useState(false);
  const [openedCategory, openCategory] = useState(activeCategoryParts && activeCategoryParts[0]);

  useEffect(() => {
    if (!open) return;
    const handleClickOutside = event => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    const timeoutId = setTimeout(() => {
      document.addEventListener('click', handleClickOutside);
    }, 0);

    // eslint-disable-next-line consistent-return
    return () => {
      clearTimeout(timeoutId);
      document.removeEventListener('click', handleClickOutside);
    };
  }, [open]);

  const handleOnToggle = (state, evt) => {
    if (evt) {
      const mousePos = [evt.clientX, evt.clientY];
      const boundingRects = containerRef.current.getBoundingClientRect();
      const containerLimits = [
        [boundingRects.left, boundingRects.left + boundingRects.width],
        [boundingRects.top, boundingRects.top + boundingRects.height]
      ];

      if (
        mousePos[0] >= containerLimits[0][0]
        && mousePos[0] <= containerLimits[0][1]
        && mousePos[1] >= containerLimits[1][0]
        && mousePos[1] <= containerLimits[1][1]
      ) {
        return;
      }
    }

    setOpen(state);
    if (state) {
      // if (typeof document !== 'undefined') {
      //   document.body.classList.add('noScroll');
      // }
    } else {
      // if (typeof document !== 'undefined') {
      //   document.body.classList.remove('noScroll');
      // }
      openCategory(activeCategoryParts && activeCategoryParts[0]);
    }
  };

  const handleOpenCategory = categoryId => {
    setTimeout(() => {
      openCategory(categories.find(category => categoryId === category.id));
    }, 0);
  };

  useScrollLock(open);

  useEffect(() => {
    if (open) {
      handleOnToggle(false);
    }
  }, [location.pathname]);

  if (isStatic) {
    return (
      <CategoriesStaticComponent
        ref={ containerRef }
        activeCategory={ activeCategory }
        openCategory={ openedCategory }
        onOpenCategory={ handleOpenCategory }
        onToggle={ handleOnToggle }
        categories={ categories || [] }
        error={ error }
        open={ open }
        isMobile={ width <= 1025 }
        isExternalReseller={ isExternalReseller }
        canAccessAccountStatements={ canAccessAccountStatements }
      />
    );
  }

  return (
    <CategoriesMenuComponent
      ref={ containerRef }
      activeCategory={ activeCategory }
      openCategory={ openedCategory }
      onOpenCategory={ handleOpenCategory }
      onToggle={ handleOnToggle }
      categories={ categories || [] }
      error={ error }
      open={ open }
      isMobile={ width <= 1025 }
      isExternalReseller={ isExternalReseller }
      canAccessAccountStatements={ canAccessAccountStatements }
    />
  );
});

CategoriesMenu.propTypes = {
  isStatic: bool,
};

CategoriesMenu.displayName = 'CategoriesMenuContainer';

export default CategoriesMenu;
